import './TopNav.css';
import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';

const mobileMenuLinks = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/products' },
  { label: 'Appointment', to: '/appointments' },
  { label: 'Face Matching', to: '/getfacematching' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'Orders', to: '/orders' },
];

function TopNav() {
  const { cart, openCart } = useCart();
  const { isAuthenticated, logout, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const firstName = user?.fullName?.split(' ')[0] || 'Profile';

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsSearchOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const currentQuery = new URLSearchParams(location.search).get('q') || '';
    setSearchValue(currentQuery);
  }, [location.search]);

  function handleSearchSubmit(event) {
    event.preventDefault();

    const nextQuery = searchValue.trim();
    navigate(nextQuery ? `/products?q=${encodeURIComponent(nextQuery)}` : '/products');
  }

  return (
    <header className="top-nav">
      <div className="top-nav__inner">
        <NavLink className="top-nav__brand" to="/">
          <span className="top-nav__brand-mark">
            <img
              className="top-nav__brand-logo"
              src="/Logo 1.png"
              alt="Lalitpur Eye Care logo"
            />
          </span>
          <span className="top-nav__brand-wordmark">Lalitpur Eye Care</span>
        </NavLink>
        <nav
          className={`top-nav__links top-nav__links--desktop ${isSearchOpen ? 'is-hidden' : ''}`}
          aria-label="Desktop"
        >
          <NavLink to="/">Home</NavLink>
          <NavLink to="/products">Products</NavLink>
          <NavLink to="/appointments">Appointment</NavLink>
          <NavLink to="/getfacematching">Face Matching</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <NavLink to="/orders">Orders</NavLink>
        </nav>
        <div className={`top-nav__icon-bar ${isSearchOpen ? 'is-hidden' : ''}`}>
          <button
            type="button"
            className="top-nav__icon-button"
            aria-label="Search products"
            onClick={() => {
              setIsMobileMenuOpen(false);
              setIsSearchOpen((current) => !current);
            }}
          >
            <span className="top-nav__icon top-nav__icon--search" />
          </button>
          <button
            type="button"
            className="top-nav__icon-button top-nav__cart-icon-button"
            aria-label="Open cart"
            onClick={() => {
              setIsMobileMenuOpen(false);
              openCart();
            }}
          >
            <span className="top-nav__icon top-nav__icon--bag" />
            <span className="top-nav__cart-count">{cart.itemCount}</span>
          </button>
        </div>
        <button
          type="button"
          className={`top-nav__menu-toggle ${isMobileMenuOpen ? 'is-open' : ''} ${isSearchOpen ? 'is-hidden' : ''}`}
          aria-expanded={isMobileMenuOpen}
          aria-controls="top-nav-menu"
          aria-label="Toggle navigation menu"
          onClick={() => {
            setIsMobileMenuOpen((current) => !current);
          }}
        >
          <span />
          <span />
          <span />
        </button>
        <div
          id="top-nav-menu"
          className={`top-nav__actions ${isMobileMenuOpen ? 'is-open' : ''}`}
        >
          <nav className="top-nav__mobile-menu" aria-label="Main">
            {mobileMenuLinks.map((link) => (
              <NavLink key={link.to} to={link.to}>
                {link.label}
              </NavLink>
            ))}
          </nav>
          <div className="top-nav__account">
          {isAuthenticated ? (
            <div className="top-nav__profile-group">
              <NavLink className="top-nav__profile-link" to="/profile">
                <span className="top-nav__profile-avatar">{firstName.slice(0, 1).toUpperCase()}</span>
                <span>{firstName}</span>
              </NavLink>
              <button
                type="button"
                className="top-nav__auth-button"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  logout();
                }}
              >
                Logout
              </button>
            </div>
          ) : (
            <div className="top-nav__profile-group">
              <NavLink className="top-nav__auth-link" to="/login">
                Login
              </NavLink>
              <NavLink className="top-nav__auth-link top-nav__auth-link--primary" to="/signup">
                Signup
              </NavLink>
            </div>
          )}
          </div>
        </div>

        <div className={`top-nav__search-overlay ${isSearchOpen ? 'is-open' : ''}`}>
          <form className="top-nav__search-form" onSubmit={handleSearchSubmit}>
            <div className="top-nav__search-main">
              <label className="top-nav__search-label" htmlFor="site-search">
                Search
              </label>
              <div className="top-nav__search-field">
                <input
                  id="site-search"
                  type="search"
                  className="top-nav__search-input"
                  placeholder="Type here to search..."
                  value={searchValue}
                  autoFocus={isSearchOpen}
                  onChange={(event) => {
                    setSearchValue(event.target.value);
                  }}
                />
                <button
                  type="submit"
                  className="top-nav__search-submit"
                  aria-label="Submit search"
                >
                  <span className="top-nav__icon top-nav__icon--search" />
                </button>
              </div>
            </div>
            <button
              type="button"
              className="top-nav__search-close"
              aria-label="Close search"
              onClick={() => {
                setIsSearchOpen(false);
              }}
            >
              ×
            </button>
          </form>
        </div>
      </div>
    </header>
  );
}

export default TopNav;
